import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import Modal from 'react-bootstrap/Modal';
import DetalleNoticia from './DetalleNoticia';
import CuadroReacciones from './CuadroReacciones';
import NuevaNoticia from './NuevaNoticia';
import ModalCargando from '../utilsComponentes/ModalCargando';
const server = process.env.REACT_APP_SERVER;
const incremento=10;
function Noticias(props) {
    const { setEnable, tipo } = props;
    const [noticias, setNoticias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [actualizar, setActualizar] = useState(0);
    const [selectNoticia, setSelectNoticia] = useState({});
    const [modalDetalle, setModalDetalle] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [idEmpleado,setIdEmpleado] =useState('');
    const [paginacion,setPaginacion] = useState(false);
    const [paginaUp,setPaginaUp] = useState(false);
    const [numPagina,setNumPagina] = useState(incremento);
    const [regional,setRegional] = useState('');
    const verDetalleInfo = (item,tipo) => {
        setSelectNoticia(item);
        if(tipo===0){
            setModalDetalle(true);
        }else{
            setModalEdit(true);
        }
    }
    const eliminarInfo =(dato)=>{
        fetch(`${server}/redSocial/removeNoticias`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: regional,
                info:dato
            })
        })
            .then(res => res.json())
            .then(data => {
                setEnable(false);
                if (data.ok) {
                    setNoticias([]);
                    setActualizar(actualizar+1);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }
    const cerrarModalEdit=()=>{
        setModalEdit(false);
        setNoticias([]);
        setActualizar(actualizar+1);
    }
    const cambiarPagina=(valor)=>{
        if(valor){
            setPaginaUp(true);
            if((numPagina+incremento)>=noticias.length){
                setPaginacion(false);
            }else{
                setPaginacion(true);
            }
            setNumPagina(numPagina+incremento);
        }else{
            setPaginacion(true);
            if((numPagina-incremento)==incremento){
                setPaginaUp(false);
            }else{
                setPaginaUp(true);
            }
            setNumPagina(numPagina-incremento);
        }
    }
    useEffect(()=>{

    },[numPagina])
    useEffect(() => {
        var info = JSON.parse(localStorage.getItem('__react_session__'));
        setIdEmpleado(info.idSession);
        setRegional(info.regional)
        if (noticias.length === 0 || actualizar !== 0) {
            fetch(`${server}/redSocial/getNoticias`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: ''+info.regional,
                    tipo,
                    idEmpleado: info.idSession
                })
            })
                .then(res => res.json())
                .then(data => {
                    setEnable(false);
                    if (data.ok) {
                        if(data.ok.length>incremento){
                            setPaginacion(true);
                        }
                        setNoticias(data.ok);
                        setLoading(false);
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                })
                .catch(err => console.log(err));
        }
    }, [actualizar])
    return (
        <div className='container-fluid overflow-auto configOverFlow py-2'>
            <ModalCargando show={loading}/>
            {paginaUp&&<div className='container text-center'>
                <button className='btn btn-sm btn-secondary bg-gradient rounded-circle' onClick={()=>cambiarPagina(false)}>
                    <i className="fa-solid fa-arrow-up "></i>
                </button>
            </div>}
            {noticias.map((item,index) => {
                if((index>=(numPagina-incremento))&& index<(numPagina)){
                return (
                    <div className="card col-sm-10 col-md-8 col-lg-4 mx-auto mb-4 bg-dark bg-gradient" key={item.ID_NOTICIA}>
                        <div className="card-header m-0 p-1">
                            <div className='row row-cols-sm-2 g-1'>
                                <div className='col col-sm-6 col-md-10 m-0 p-0 my-auto'>
                                    <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                                        {UtilsBufer.getFotoCard(item.FOTO, 30)}
                                        <div className='ps-2 my-auto text-light '>
                                            <div className="noticiasHeader fw-bold">{item.NOMBREX}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col col-sm-4 col-md-2 text-end m-0 p-0 my-auto'>
                                    <div className="btn-group btn-group-sm" role="group" aria-label="Basic example">
                                        {idEmpleado===item.ID_EMPLEADO&&
                                        <button className="btn btn-sm btn-transparent bg-gradient p-0 m-0 text-light " 
                                            data-bs-toggle="modal" data-bs-target="#exampleModal"
                                            onClick={()=>setSelectNoticia(item)}>
                                            <i className="fa-regular fa-trash-can fa-xl"></i>
                                        </button>}
                                        {idEmpleado===item.ID_EMPLEADO&&
                                        <button className="btn btn-sm btn-transparent bg-gradient p-0 m-0 text-light mx-2"
                                            onClick={()=> verDetalleInfo(item,1)}>
                                            <i className="fa-solid fa-pen-to-square fa-xl"></i>
                                        </button>}
                                        <button className="btn btn-sm btn-transparent bg-gradient p-0 m-0 text-light "
                                            onClick={() => verDetalleInfo(item,0)}>
                                            <i className="fa-solid fa-ellipsis fa-xl"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div onClick={() => verDetalleInfo(item,0)} className='text-center'>
                            <img src={`${server}/imagenes/${item.NOMBRE_IMG}`} className='img-fluid' style={{ maxHeight: "400px" }}></img>
                        </div>
                        <div className='card-footer p-0 m-0'>
                            <div className='row row-cols-2 g-0 m-0 p-0'>
                                <div className='col-10'>
                                    <CuadroReacciones item={item} regional={regional}/>
                                </div>
                                <div className='col-2'>
                                    <button className="btn btn-sm btn-primary bg-gradient text-light"
                                        onClick={() => verDetalleInfo(item,0)}>
                                        Ver mas
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className='row row-cols-2 g-0'>
                                <div className='col-11'>
                                    <div className="card-title text-light">{item.TITULO}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            })}
            {paginacion&&<div className='container text-center '>
                <button className='btn btn-sm btn-secondary bg-gradient rounded-circle' onClick={()=>cambiarPagina(true)}>
                    <i className="fa-solid fa-arrow-down"></i>
                </button>
            </div>}
            <Modal show={modalDetalle} onHide={() => setModalDetalle(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                            <div className='fa-beat-fade'>{UtilsBufer.getFotoCard(selectNoticia.FOTO, 40)}</div>
                            <div className='ps-2 my-auto text-light'>
                                <div className="noticiasHeader fw-bold">{selectNoticia.NOMBREX}</div>
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DetalleNoticia info={selectNoticia} regional={regional}/>
                </Modal.Body>
            </Modal>
            <Modal show={modalEdit} onHide={cerrarModalEdit}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>Editar Noticia</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <NuevaNoticia cerrarModalAdd={cerrarModalEdit} info={selectNoticia}/>
                </Modal.Body>
            </Modal>
            <div className="modal fade" id="exampleModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog ">
                    <div className="modal-content bg-dark bg-gradient text-light">
                    <div className="modal-header m-0 p-0 mx-2">
                        <h5 className="modal-title" id="exampleModalLabel">Eliminando Noticia</h5>
                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <i className="fa-solid fa-circle-info fa-2xl"></i> Seguro que quiere eliminar la noticia?
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={()=>eliminarInfo(selectNoticia)}>Si</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Noticias
